export default __webpack_public_path__ + "static/media/Astro_rideLean-min2.5a4f6952.png";